<template>
  <div class="info-box">
    <div class="content">
      <slot></slot>
    </div>
    <div class="caption">{{caption}}</div>
  </div>
</template>

<script>
export default {
  props: {
    caption: String
  }
};
</script>

<style scoped>
.info-box {
  background: black;
  border-radius: 4px;
  padding: 5px;
  display: flex;
  flex-direction: column;
}
.content {
  flex: 1 1 auto;
}
.content > *:not(:first-child) {
  margin-top: 2px;
}

.caption {
  flex: 0 0 auto;
  font-size: 75%;
  align-self: center;
  text-align: center;
}
</style>
